<template>
    <v-dialog v-model="mostrar" width="70%" max-width="70%" :fullscreen="$root.isTouch"  persistent>
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="cerrarModalPdf">
                    <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title class="headline text-white"  v-html="titulo"></v-toolbar-title>
            </v-toolbar>
            <v-card-text class="p-0">
                <v-container fluid grid-list-sm class="p-0">
                    <v-row class="p-0">
                        <v-col cols="12" sm="12" id="content-object">
                            <object type="application/pdf" 
                                    :data="base64"  
                                    style="width:100% !important; height: 600px"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    inject:['cerrarModalPdf'],
    props:{
        mostrar:{
            type   :Boolean,
            default: false
        },
        titulo:{
            type: String,
            default: ''
        },
        base64:{
            type: String,
            default: ''
        }
    },
    watch:{
        mostrar(val){
            if(val && this.$root.isTouch){
                var pdfResult = _.split(this.base64,",")[1];
                var element = document.createElement('a');
                element.setAttribute('href', `data:application/pdf;base64, ${encodeURI(pdfResult)}`);
                element.setAttribute('download', this.titulo);
                element.style.display = 'none';
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
                this.cerrarModalPdf();
            }
        }
    }
}
</script>